<template>
  <tr>
  	<td v-if="showCode">{{item.item_code}}</td>
    <td>{{item.title}}</td>
    <!-- <td>{{item.unit_name}}</td> -->
    <!-- <td class="text-xs-right" v-if="showPrice">{{ item.rate | roundValue }}</td> -->
    <td :class="viewMode || approveMode ? 'text-xs-right' : 'text-xs-left'">{{purchaseQty}}</td>
    <td class="text-xs-right">
      <span v-if="viewMode || approveMode">{{ item.quantity }}</span>
      <v-edit-dialog v-else :return-value="quantity" lazy @open="open" @close="close"> {{ item.quantity }}
        <v-text-field type="number" :rules="quantityRules" slot="input" v-model="quantity" label="Enter Quantity" single-line></v-text-field>
      </v-edit-dialog>
    </td>
    <td class="text-xs-right" v-if="showPrice">{{ item.total | roundValue }}</td>
    <td class="align-right justify-end layout px-2" v-if="!viewMode && !approveMode">
      <v-btn flat icon @click="$emit('delete', index)">
        <v-icon color="red">clear</v-icon>
      </v-btn>
    </td>
  </tr>
</template>
<script>

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    purchaseItems: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    viewMode: {
      type: Boolean,
      default: false
    },
    approveMode: {
      type: Boolean,
      default: false
    },
    showPrice: {
      type: Boolean,
      default: true
    },
    showCode: {
      type: Boolean,
      default: true
    },
    showTax: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      quantity: 0,
      quantityRules: [
        v => !!v || 'Quantity is required',
        v => /^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Quantity must be valid'
      ]
    }
  },
  
  methods: {
  	open () {
      this.quantity = this.item.quantity
    },
    close () {
      this.item.quantity = this.item.allow_decimal ? this.quantity : parseInt(this.quantity)
    },
  },

  mounted () {
  	this.item.total = this.item.quantity * ( this.item.rate + this.item.tax )
  },

  computed: {
    
    itemTotal () {
      return this.quantity * ( this.item.rate + this.item.tax )
    },
    
    purchaseQty() {
      let qty = 0
      let current = this.purchaseItems.filter(item => item.item_id === this.item.item_id)
      if (current.length > 0) {
        current = current[0]
        qty = current.quantity
      }
      return qty
    }

  },

  watch: {

    itemTotal (val) {
      if (val) {
        this.item.total = val
      }
    },

    'item.quantity' (val, oldVal) {
      if (!val || val < 0) {
        return this.item.quantity = 0
      }
      else if(val > this.purchaseQty){
        return this.item.quantity = this.purchaseQty
      }
    }
    
  }
}
</script>